import React from "react";
import TransferSidebar from './TransferSidebar'
import "./TransferJob.css";
import Autocompete from '../JobRequisition/Autocompete'
import TransferHeader from './TransferHeader'

const Job = () => {
   
  return (
    
 <div className='job'>
<TransferHeader/>

     <div class ="jobProcess">
    <TransferSidebar/>
     <div className="tranfer-job-container">
      <br/>
        <h1>Job Profile</h1>
     <div className='job-title'>Job Profile</div>
     <br/>
     <div className="job-ans"><Autocompete/></div>
    
     <div className='job-title'>Job Title <span className="mandatory">*</span></div>
     <div className="job-ans"> <Autocompete/></div>
    
    <div className="business-title">
        <h1>Business Title</h1>
        <div className='job-title'>Business Title <span className="mandatory">*</span></div>
     <div className="job-ans"> <Autocompete/></div>
     
    </div>
    <div className='next-bar'>
    <button className='back-btn'>Back</button>
    <button className='next-btn'>Next</button>
          
    </div>
    </div>
    </div> 
    </div>
  );
}
export default Job;